<script lang="ts" setup>
  import { ShopManagementListView } from '@/views/shop/management'

  import { useShopManagementPage } from './model/useShopManagementPage'

  definePage({
    meta: {
      layout: 'baseNew',
      shopManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: computed(() => t('page_title_shop_management')),
  })

  const { actions, editableFields, labels, list, modals, pagination, selection } = useShopManagementPage()
</script>

<template>
  <ShopManagementListView
    :actions="actions"
    :editable-fields="editableFields"
    :labels="labels"
    :list="list"
    :modals="modals"
    :pagination="pagination"
    :selection="selection"
  />
</template>
